// extracted by mini-css-extract-plugin
export default {"otherPaymentMethods":"elRB7i","arrowIcon":"Uy7Coh","arrowIconWhite":"hO4gsr"};